import { useLang } from "@/context/LanguageContext";

const LANGS = [
  { code: "fr", label: "FR" },
  { code: "nl", label: "NL" },
  { code: "en", label: "EN" },
];

export function LanguageSwitcher({ className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex items-center border border-white/15 ${className}`} data-testid="language-switcher">
      {LANGS.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          data-testid={`lang-${l.code}`}
          className={`px-2.5 py-1 font-mono-tech text-[11px] tracking-[0.1em] transition-colors ${
            lang === l.code ? "bg-[#E60000] text-white" : "text-zinc-400 hover:text-white"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
